
<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";
  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();

  const props = defineProps({
    configsOptions: Array,
  });

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));

  let isSubmitted = ref(false);
  let id = ref(null);
  let name = ref(null);
  let type = ref(null);
  let devicesNames = ref([]);
  let mac_address = ref(null);
  let mac_addresses = ref([]);
  const company_id = useCompanyStore().companyId;
  let config = ref(null);
  let config_id = ref(null);
  let buttonText = ref(null);
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  const changeConfigVal = (newConfig) => {
    if(newConfig && newConfig.id == config_id.value) buttonText.value = 'Re-install';
    else buttonText.value = 'Install';
  }

  const onSubmit = () => {
    isSubmitted.value = true;

    let data = {};
    let action = '';
    if(getModalAction.value == 'device_config' || getModalAction.value == 'mass_devices_config'){
      if(getModalAction.value == 'device_config'){
        action = 'applyConfig'
      }else{
        action = 'massApplyConfigs'
      }

      data = { 
        entityId: company_id,
        kioskName : getModalAction.value == 'device_config' ? name.value : devicesNames.value,
        macAddress : getModalAction.value == 'device_config' ? mac_address.value : '',
        macAddresses : getModalAction.value == 'mass_devices_config' ? mac_addresses.value : '',
        userName : user.value.first_name+' '+ user.value.last_name,
        userId : user.value.user_id,
        connectionType : 'daemon',
        config : config.value,
      }

    }else{

      action = 'applySiteAndAreaConfig';
      data = {
        id : id.value, 
        type : type.value,
        company_id : company_id,
        config_id : config.value.id,
      }
      
    }

    devicesStore[action](data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });

  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'device_config'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
      config.value = getModalInfo.value.configuration;
      config_id.value = getModalInfo.value.configuration.id;
      mac_address.value = getModalInfo.value.mac_address;
      type.value = getModalInfo.value.data_type;
      buttonText.value = 'Re-install';
      
    }else if(getModalAction.value == 'mass_devices_config') {
      // Guard restored: this branch only became reachable once the modal's v-if
      // started accepting mass_devices_config, and an unguarded .map() throws
      // for any non-array payload. Matches the sibling mass-action modals.
      if(Array.isArray(getModalInfo.value)){
        getModalInfo.value.map((row) =>{
          devicesNames.value.push(row.name)
          mac_addresses.value.push(row.mac_address)
        });
        name.value = devicesNames.value.toString();
      }
    }else if(getModalAction.value == 'site_config' || getModalAction.value == 'area_config'){
      id.value = getModalInfo.value.id;
      name.value = getModalInfo.value.name;
      type.value = getModalInfo.value.data_type;
      if(getModalInfo.value.configuration){
        config.value = getModalInfo.value.configuration;
        config_id.value = getModalInfo.value.configuration.id;
        buttonText.value = 'Re-install';
      }else{
        buttonText.value = 'Install';
      }
    }
  });

</script>

<template>
  <DModal v-if="['device_config', 'mass_devices_config', 'site_config', 'area_config'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Install Configuration </template>

    <template #body>
      <div class="delete-text mb-3">
        <span v-if="type === 'device'">Select the configuration you want to <b>"Install"</b> on the device "{{ name }}" ?</span>
        <span v-if="type === 'site'">Select the configuration you want to <b>"Install"</b> on the site "{{ name }}" ?</span>
        <span v-if="type === 'area'">Select the configuration you want to <b>"Install"</b> on the area "{{ name }}" ?</span>
      </div>

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="config"
          inputId="config"
          :options="props.configsOptions"
          optionLabel="name"
          dataKey="id"
          class="w-full"
          filter
          filterPlaceholder="Search by configuration name"
          @change="changeConfigVal($event.value)"
        />
        <label for="config">Configuration</label>
      </FloatLabel>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!config || isSubmitted " 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
          {{ buttonText }} <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
